<template>
  <div class="vehicle-animation">
    <div class="exhaust-container">
      <div class="exhaust-puff puff-1"></div>
      <div class="exhaust-puff puff-2"></div>
      <div class="exhaust-puff puff-3"></div>
    </div>
    <div class="vehicle-icon">
      <svg viewBox="0 0 72 36" width="54" height="27">
        <!-- main body with short hood -->
        <path d="M 4 8 L 58 8 L 58 15 L 64 15 Q 66 15, 66 17 L 66 23 L 4 23 Z" fill="#FFB800"/>
        <!-- black bumper area -->
        <rect x="4" y="23" width="64" height="3" fill="#222"/>
        <!-- roof edge -->
        <rect x="4" y="7" width="54" height="2" fill="#e6a600"/>
        <!-- passenger windows -->
        <rect x="6" y="10" width="7" height="7" rx="1" fill="#222"/>
        <rect x="15" y="10" width="7" height="7" rx="1" fill="#222"/>
        <rect x="24" y="10" width="7" height="7" rx="1" fill="#222"/>
        <rect x="33" y="10" width="7" height="7" rx="1" fill="#222"/>
        <rect x="42" y="10" width="7" height="7" rx="1" fill="#222"/>
        <rect x="51" y="10" width="5" height="12" rx="1" fill="#222"/>
        <!-- entry door -->
        <rect x="56" y="10" width="1" height="13" fill="#333"/>
        <!-- stop sign arm (folded) -->
        <rect x="4" y="13" width="1" height="6" fill="#cc0000"/>
        <!-- SCHOOL BUS text area -->
        <rect x="18" y="19" width="26" height="3" fill="#222"/>
        <!-- wheels -->
        <circle cx="16" cy="28" r="5" fill="#222"/>
        <circle cx="16" cy="28" r="3" fill="#444"/>
        <circle cx="16" cy="28" r="1" fill="#666"/>
        <circle cx="54" cy="28" r="5" fill="#222"/>
        <circle cx="54" cy="28" r="3" fill="#444"/>
        <circle cx="54" cy="28" r="1" fill="#666"/>
        <!-- headlights -->
        <rect x="64" y="17" width="2" height="3" rx="1" fill="#ffdd00"/>
        <!-- taillights -->
        <rect x="4" y="18" width="2" height="3" rx="1" fill="#cc0000"/>
        <!-- side mirror -->
        <rect x="64" y="10" width="3" height="2" rx="0.5" fill="#333"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SchoolBusAnimation'
}
</script>

<style scoped>
.vehicle-animation {
  display: flex;
  align-items: center;
}

.exhaust-container {
  position: relative;
  width: 0px;
  height: 24px;
  margin-left: 20px;
}

.exhaust-puff {
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #999;
  border-radius: 50%;
  opacity: 0;
  right: 0;
}

.puff-1 {
  bottom: 4px;
  animation: puff-float 1.2s ease-out infinite;
}

.puff-2 {
  bottom: 8px;
  animation: puff-float 1.2s ease-out infinite 0.4s;
}

.puff-3 {
  bottom: 12px;
  animation: puff-float 1.2s ease-out infinite 0.8s;
}

.vehicle-icon {
  animation: vehicle-bounce 0.5s ease-in-out infinite;
}

@keyframes vehicle-bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-2px); }
}

@keyframes puff-float {
  0% {
    opacity: 0.7;
    transform: translateX(0) scale(0.5);
  }
  100% {
    opacity: 0;
    transform: translateX(-15px) scale(1.2);
  }
}
</style>
